import React from 'react';
import { Chip, type ChipProps } from '@mui/material';
import {
  Edit as DraftIcon,
  RateReview as ReviewIcon,
  CheckCircle as ApprovedIcon,
  Schedule as ScheduledIcon,
  Public as PublishedIcon,
} from '@mui/icons-material';
import type { ContentStatus } from '../../services/api-client';

const STATUS_CONFIG: Record<
  ContentStatus,
  { label: string; color: ChipProps['color']; icon: React.ReactElement }
> = {
  draft: { label: 'Draft', color: 'default', icon: <DraftIcon fontSize="small" /> },
  in_review: { label: 'In Review', color: 'warning', icon: <ReviewIcon fontSize="small" /> },
  approved: { label: 'Approved', color: 'info', icon: <ApprovedIcon fontSize="small" /> },
  scheduled: { label: 'Scheduled', color: 'secondary', icon: <ScheduledIcon fontSize="small" /> },
  published: { label: 'Published', color: 'success', icon: <PublishedIcon fontSize="small" /> },
};

interface ContentStatusChipProps {
  status: ContentStatus;
  size?: 'small' | 'medium';
}

export default function ContentStatusChip({ status, size = 'small' }: ContentStatusChipProps) {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.draft;
  return (
    <Chip
      icon={config.icon}
      label={config.label}
      color={config.color}
      size={size}
      variant="outlined"
      sx={{ fontWeight: 500 }}
    />
  );
}
